import type { AnonymousCustomersReport } from '@vy/types';
import { withDefault } from '@vy/utils';
import { VyTableLite } from '../../../../../components/new-design/table/vy-table/VyTable';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';
import { ANONYMOUS_CUSTOMERS_COLUMNS } from './anonymous-customers-columns';
import { GridApiPro } from '@mui/x-data-grid-pro';

type AnonymousCustomersReportTableProps = {
  rows: AnonymousCustomersReport;
  filter?: string;
  apiRef?: React.MutableRefObject<GridApiPro>;
  isLoading?: boolean;
};

export const AnonymousCustomersReportTable: React.FC<AnonymousCustomersReportTableProps> = ({
  isLoading,
  filter,
  rows,
  apiRef,
}) => {
  const navigate = useVyNavigate();
  const customers = withDefault(rows?.customers, []);

  const filterCustomers = customers.filter(
    ({ name }) => !filter || name.toLowerCase().includes(filter.toLowerCase()),
  );

  console.log(filterCustomers)

  return (
    <VyTableLite
      apiRef={apiRef}
      items={filterCustomers}
      columns={ANONYMOUS_CUSTOMERS_COLUMNS}
      loadingItems={isLoading}
      getRowId={(row) => row.id}
      onRowClick={({ row: { id } }) => navigate(`../../customers/${id}/settings`)}
    />
  );
};
